import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { useAuth } from '../contexts/AuthContext';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { user: userContextUser } = useContext(UserContext);
  const { user: authUser } = useAuth();
  const user = userContextUser || authUser;
  const token = localStorage.getItem('token');

  const handleAccountClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (token || user) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  };

  return (
    <header className="header-section w-full px-6 md:px-12 lg:px-20 py-6 flex items-center justify-between">
      {/* Logo */}
      <div className="flex items-center">
        <img src="/images/logo.png" alt="AdSmash Logo" className="h-10 md:h-12" />
      </div>

      {/* Navigation and CTA Button - Right Side */}
      <div className="flex items-center gap-8">
        {/* Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <a href="#pricing" className="text-white hover:text-gray-300 transition-colors">
            Pricing
          </a>
          <a href="#about" className="text-white hover:text-gray-300 transition-colors">
            About
          </a>
          <a href="#contact" className="text-white hover:text-gray-300 transition-colors">
            Contact
          </a>
          <a 
            href="#" 
            onClick={handleAccountClick}
            className="text-white hover:text-gray-300 transition-colors cursor-pointer"
          >
            Account
          </a>
        </nav>

        {/* CTA Button */}
        <Link 
          to="/payment"
          className="btn-adsmash-primary text-white px-6 py-2 rounded-md font-semibold transition-all shadow-lg inline-block"
        >
          Buy now
        </Link>
      </div>
    </header>
  );
};

export default Header;

